<template>
  <div class="container">
    <h1>{{ $route.meta.title }}</h1>
    <user-form :model="$route.meta.model"></user-form>
  </div>
</template>

<script>
import UserForm from './Form'

export default {
  components: { UserForm },
}
</script>
